module.exports = __webpack_public_path__ + "img/22.b010a444.jpg";